export const Permission = {
  administration: {
    module: "administration",
    adminTerms: "adminTerms",
    adminVehicles: "adminVehicles",
    adminSatelliteLock: "adminSatelliteLock",
    adminTrailers: "adminTrailers",
    adminCompanies: "adminCompanies",
    adminCities: "adminCities",
    adminUsers: "adminUsers",
    showDocumentsPendingDrivers: "showDocumentsPendingDrivers",
    validateDocumentsPendingDrivers: "validateDocumentsPendingDrivers",
    showSecurityAnalysis: "showSecurityAnalysis",
    disableEnableUsers: "disableEnableUsers",
    disableEnableDriver: "disableEnableDriver",
    setupMonitorIntegration: "setupMonitorIntegration",
    truoraConfiguration: "truoraConfiguration",
    vehicleDocumentsConfiguration: "vehicleDocumentsConfiguration",
    activateByScore: "activateByScore",
    createTermsConditions: "createTermsConditions",
    downloadFileRegistreBank: "downloadFileRegistreBank",
    createVehicle: "createVehicle",
    updateVehicle: "updateVehicle",
    editFieldsRUNT: "editFieldsRUNT",
    activateVehicle: "activateVehicle",
    updateBankAdvance: "updateBankAdvance",
    updateBankBalance: "updateBankBalance",
    createCompany: "createCompany",
    updateCompany: "updateCompany",
    createRoles: "createRoles",
    updateRoles: "updateRoles",
    changeRole: "changeRole",
    adminRoles: "adminRoles",
    adminModules: "adminModules",
    changeDriverVehicle: "changeDriverVehicle",
    validateAndRemarkVehicleReferences: "validateAndRemarkVehicleReferences",
    showCreateGps: "showCreateGps",
    modifyBasicFieldsUser: "modifyBasicFieldsUser",
    showDeleteGps: "showDeleteGps",
    useGpsPortable: "useGpsPortable",
    alertValidGps: "alertValidGps",
    editCompliments: "editCompliments",
    createCompanyComplimentType: "createCompanyComplimentType",
    editTags: "editTags",
    updateCity: "updateCity",
    linkCities: "linkCities",
    addSubCities: "addSubCities",
    deleteSubCities: "deleteSubCities",
    createEmailCompany: "createEmailCompany",
    forceVehicleActivation: "forceVehicleActivation",
    deactivateVehicle: "deactivateVehicle",
    validateVehicleDocuments: "validateVehicleDocuments",
    editAdminVehicle: "editAdminVehicle",
    editOwnerVehicle: "editOwnerVehicle",
    editGpsVehicle: "editGpsVehicle",
    editReferencesVehicle: "editReferencesVehicle",
    reactivateVehicleByInactivity: "reactivateVehicleByInactivity",
    changeFeeToOwnedFleet: "changeFeeToOwnedFleet",
    changeValidationRules: "changeValidationRules",
    changeRolNotifications: "changeRolNotifications",
    adminMaintenance: "adminMaintenance",
    maintenanceDetail: "maintenanceDetail",
    createMaintenance: "createMaintenance",
    editMaintenance: "editMaintenance",
    deleteMaintenance: "deleteMaintenance",
    updatePolicy: "updatePolicy",
    setUpPolicy: "setUpPolicy",
    changeCommercial: "changeCommercial",
    createDriver: "createDriver",
    changeFleetLoyalty: "changeFleetLoyalty",
    changeVehicleFleetLoyalty: "changeVehicleFleetLoyalty",
    adminThirdParty: "adminThirdParty",
    createThirdParty: "createThirdParty",
    createThirdPartyAddress: "createThirdPartyAddress",
    editAdditionalServicesUtilities: "editAdditionalServicesUtilities",
    updateCompanyUtilitiesUnrestricted: "updateCompanyUtilitiesUnrestricted",
    editThirdPartyAddress: "editThirdPartyAddress",
    activateOrDeactivateCompany: "activateOrDeactivateCompany",
    disableEnableThirdParty: "disableEnableThirdParty",
    viewDeletedThirdpartyAddresses: "viewDeletedThirdpartyAddresses",
    deleteEmailCompany: "deleteEmailCompany",
    routeDetourConfiguration: "routeDetourConfiguration",
    transportCompanyBlackListConfiguration: "transportCompanyBlackListConfiguration",
    riskProfileConfiguration: "riskProfileConfiguration",
    createSatelliteLock: "createSatelliteLock",
    updateSatelliteLock: "updateSatelliteLock",
    deleteSatelliteLock: "deleteSatelliteLock",
    reassignTrailer: "reassignTrailer",
    requestValidation: "requestValidation",
    manageSecurityStudy: "manageSecurityStudy",
    requiresPreValidation: "requiresPreValidation",
    prebillRequiresValidation: "prebillRequiresValidation",
  },
  cargo: {
    module: "cargo",
    createRoundedCargo: "createRoundedCargo",
    createManualCargo: "createManualCargo",
    createCargoRequest: "createCargoRequest",
    viewRndc: "viewRndc",
    changeManifestRequirement: "changeManifestRequirement",
    //createCargoByGuides: "createCargoByGuides",
    createMassiveCargo: "createMassiveCargo",
    createCargoFromRoute: "createCargoFromRoute",
    createEscortService: "createEscortService",
    cargoRequest: "cargoRequest",
    cargoRequestNegotiation: "cargoRequestNegotiation",
    cargosInRoute: "cargosInRoute",
    scheduledCargo: "scheduledCargo",
    cargosInNegotiation: "cargosInNegotiation",
    finishedCargos: "finishedCargos",
    reports: "reports",
    searchCargo: "searchCargo",
    cargoItemFinancier: "cargoItemFinancier",
    registerLocation: "registerLocation",
    showManifestError: "showManifestError",
    rateCargo: "rateCargo",
    uploadExternalManifest: "uploadExternalManifest",
    editTravelExpenses: "editTravelExpenses",
    removeTravelExpenses: "removeTravelExpenses",
    removeAcceptedTravelExpenses: "removeAcceptedTravelExpenses",
    readDriverDetails: "readDriverDetails",
    documentManifest: "documentManifest",
    documentManifestUrban: "documentManifestUrban",
    documentConsignment: "documentConsignment",
    documentConsignmentUrban: "documentConsignmentUrban",
    documentOrderVehicle: "documentOrderVehicle",
    readManifest: "readManifest",
    watchLiveGPS: "watchLiveGPS",
    modifyShippingCost: 'modifyShippingCost',
    editCompliment: "editCompliment",
    readCargoCompliments: "readCargoCompliments",
    editCargoComplimentRequirements: "editCargoComplimentRequirements",
    editCargoCompliments: "editCargoCompliments",
    readDeletedCargoCompliments: "readDeletedCargoCompliments",
    complimentsFingerprint: "complimentsFingerprint",
    uploadEvidences: 'uploadEvidences',
    uploadExtraDocumentsCargo: 'uploadExtraDocumentsCargo',
    confirmLicensePlate: 'confirmLicensePlate',
    assignLicensePlate: 'assignLicensePlate',
    startCargo: 'startCargo',
    removeCargo: 'removeCargo',
    cancelCargo: 'cancelCargo',
    approvePayments: 'approvePayments',
    expiredCargo: 'expiredCargo',
    showRateCargo: 'showRateCargo',
    showTotalCostCargo: 'showTotalCostCargo',
    showPaymentCargo: 'showPaymentCargo',
    showAnomaliesCargo: 'showAnomaliesCargo',
    restoreCargo: 'restoreCargo',
    finishCargo: 'finishCargo',
    changeCompany: 'changeCompany',
    reportAnomalies: 'reportAnomalies',
    changeRteica: 'changeRteica',
    transportedValueSemaphore: 'transportedValueSemaphore',
    paymentSemaphore: 'paymentSemaphore',
    approveSemaphore: 'approveSemaphore',
    showBillingData: 'showBillingData',
    deletedCargo: 'deletedCargo',
    changeRateFullAccess: 'changeRateFullAccess',
    changeCargoLoadDate: 'changeCargoLoadDate',
    additionalCosts: 'additionalCosts',
    additionalCostCreate: 'additionalCostCreate',
    additionalCostUpdate: 'additionalCostUpdate',
    additionalCostDelete: 'additionalCostDelete',
    showCostCargo: 'showCostCargo',
    editAnomalies: 'editAnomalies',
    continueTripWithoutEvidences: "continueTripWithoutEvidences",
    removeEvidences: "removeEvidences",
    editCargo: "editCargo",
    advanceRequest: "advanceRequest",
    moveAdvance: "moveAdvance",
    useCarNearExpirationDocuments: "useCarNearExpirationDocuments",
    approveBalanceDriver: "approveBalanceDriver",
    specialLicensePlate: "specialLicensePlate",
    confirmationAdditionalMandatoryServices:
      "confirmationAdditionalMandatoryServices",
    editWeightConsignment: "editWeightConsignment",
    editCargoAmount: "editCargoAmount",
    bonusAndDiscountsInCargoRejected: "bonusAndDiscountsInCargoRejected",
    sendEmailReportsLastLocations: "sendEmailReportsLastLocations",
    createCargosWithoutMinimumUtility: "createCargosWithoutMinimumUtility",
    showCreationDateCargo: "showCreationDateCargo",
    editCargoTags: "editCargoTags",
    restartCargo: "restartCargo",
    approveCargoUnrestricted: "approveCargoUnrestricted",
    removeCargoUnrestricted: "removeCargoUnrestricted",
    removeCargoWithPayments: "removeCargoWithPayments",
    createRequestFromManualCreationCargo: "createRequestFromManualCreationCargo",
    changeTransportCompany: "changeTransportCompany",
    createCargoFromRequest: "createCargoFromRequest",
    loadDownloadStatePoints: "loadDownloadStatePoints",
    trackingReports: "trackingReports",
    addDocumentsSupport: "addDocumentsSupport",
    saveDriverDocuments: "saveDriverDocuments",
    sendEmailReport: "sendEmailReport",
    editAdvance: "editAdvance",
    deletePayment: "deletePayment",
    deleteBalancePayment: "deleteBalancePayment",
    editTypeVehicle: "editTypeVehicle",
    addObservation: "addObservation",
    earlyUploadEvidences: "earlyUploadEvidences",
    readVehicleDetails: "readVehicleDetails",
    turn: "turn",
    turnCreation: "turnCreation",
    editTurn: "editTurn",
    deleteTurn: "deleteTurn",
    viewAvailableLoads: "viewAvailableLoads",
    assignAvailableLoads: "assignAvailableLoads",
    viewTurnVehicles: "viewTurnVehicles",
    assignTurnVehicles: "assignTurnVehicles",
    additionalServicesWithoutUtilityRestriction: "additionalServicesWithoutUtilityRestriction",
    viewApproveInfo: "viewApproveInfo",
    approvedBelowSicetac: "approvedBelowSicetac",
    evidencesFingerprint: "evidencesFingerprint",
    startServiceWithArlExpired: "startServiceWithArlExpired",
    startServiceWithEpsExpired: "startServiceWithEpsExpired",
    startServiceWithAdditionalCertificationsInvalid: "startServiceWithAdditionalCertificationsInvalid",
    enableSimultaneousInrouteLoading: "enableSimultaneousInrouteLoading",
    useCarWithExpiredDocuments: "useCarWithExpiredDocuments",
    payWithTravelExpenses: "payWithTravelExpenses",
    changeApprovedTravelExpenses: "changeApprovedTravelExpenses",
    reverseInitialComplitment: "reverseInitialComplitment",
    createBonusOrPenaltyToCargo: "createBonusOrPenaltyToCargo",
    serviceRequests: "serviceRequests",
    createTransportRequests: "createTransportRequests",
    automaticTotalCostCalculation: "automaticTotalCostCalculation",
    showOriginAddresses: "showOriginAddresses",
    showDestinationAddresses: "showDestinationAddresses",
    allowToEditGeneralDataModule: "allowToEditGeneralDataModule",
    showEditTagsModule: "showEditTagsModule",
    editServiceTypeModule: "editServiceTypeModule",
    showServiceTypeModule: "showServiceTypeModule",
    editServiceCharacteristicsModule: "editServiceCharacteristicsModule",
    showServiceCharacteristicsModule: "showServiceCharacteristicsModule",
    editLoadDownloadModule: "editLoadDownloadModule",
    showInitialFulfill: "showInitialFulfill",
    showLoadDownloadModule: "showLoadDownloadModule",
    showFinancialInformationModule: "showFinancialInformationModule",
    showEditFinancialInformationModule: "showEditFinancialInformationModule",
    showEditServiceNegotiationModule: "showEditServiceNegotiationModule",
    showEditRequestNegotiationModule: "showEditRequestNegotiationModule",
    showEndServiceInfoModule: "showEndServiceInfoModule",
    showDeleteServiceInfoModule: "showDeleteServiceInfoModule",
    showAssignedServiceInfoModule: "showAssignedServiceInfoModule",
    showApprovalServiceInfoModule: "showApprovalServiceInfoModule",
    showDriverInfoModule: "showDriverInfoModule",
    showEscortInfoModule: "showEscortInfoModule",
    showActionsServiceModule: "showActionsServiceModule",
    createService: "createService",
    confirmLicensePlateOfLowRiskCargo: "confirmLicensePlateOfLowRiskCargo",
    duplicateTransportRequest: "duplicateTransportRequest",
    createCargoWithRateOrCostZero: "createCargoWithRateOrCostZero",
    generateManifest: "generateManifest",
    changeAssignSecondDriver: "changeAssignSecondDriver",
    deleteSecondDriver: "deleteSecondDriver",
    activateSecondDriver: "activateSecondDriver",
    createServicesWithExpiredPolicy: "createServicesWithExpiredPolicy",
    editPublicationZone: "editPublicationZone",
    editConsignment: "editConsignment",
    assignUnassignCostCenterToService: "assignUnassignCostCenterToService",
    showConsignmentServiceModule: "showConsignmentServiceModule",
    editConsignmentServiceModule: "editConsignmentServiceModule",
    showCargoCreator: "showCargoCreator",
    editCargoFingerprint: "editCargoFingerprint",
    deleteBonusesAndDiscounts: "deleteBonusesAndDiscounts",
    showDeletedBonusesAndDiscounts: "showDeletedBonusesAndDiscounts",
    showDeletedPayments: "showDeletedPayments",
    editAddressCargoDurationTime: "editAddressCargoDurationTime",
    linkServices: "linkServices",
    unlinkServices: "unlinkServices",
    editRiskProfile: "editRiskProfile",
    overrideRiskValidation: "overrideRiskValidation",
    approveRejectedInspection: "approveRejectedInspection",
    viewLogisticTimes: "viewLogisticTimes",
    editLogisticTimes: "editLogisticTimes",
    cancelManifest: "cancelManifest",
    generateNewConsignment: "generateNewConsignment",
    deleteConsignment: "deleteConsignment",
    editSatelliteLockModule: "editSatelliteLockModule",
    createSatelliteLockService: "createSatelliteLockService",
    assignSatelliteLock: "assignSatelliteLock",
    showTrailerReassignmentInfoModule: "showTrailerReassignmentInfoModule",
    createApplications: "createApplications",
    editApplications: "editApplications",
    approveBonusFromApplication: "approveBonusFromApplication",
    reduceScheduledTransportFreightCost: "reduceScheduledTransportFreightCost",
    viewFreightCostChangeHistory: "viewFreightCostChangeHistory",
    viewRoutePlanChangeHistory: "viewRoutePlanChangeHistory",
    panelAssignments: "panelAssignments",
    changeDispatchState: "changeDispatchState",
    viewHistoryDispatchStateChanges: "viewHistoryDispatchStateChanges",
    approveRndcWithoutAuthorization: "approveRndcWithoutAuthorization",
    viewRndcApprovalFingerprint: "viewRndcApprovalFingerprint",
    retransmitRndc: "retransmitRndc",
    replicateChanges: "replicateChanges",
    viewRndcFulfillManifestConsignmentHistory: "viewRndcFulfillManifestConsignmentHistory",
    prevalidationCargos: "prevalidationCargos",
    validateCargo: "validateCargo",
    reverseValidateCargo: "reverseValidateCargo",
    viewValidateCargoInfo: "viewValidateCargoInfo",
  },
  payments: {
    module: "payments",
    approveBankAdvance: "approveBankAdvance",
    approveBankBalance: "approveBankBalance",
    approvePayments: "approvePayments",
    charges: "charges",
    createCostCenter: "createCostCenter",
    associateCostCenter: "associateCostCenter",
    paymentExtraAdvance: "paymentExtraAdvance",
    billingXML: "billingXML",
    reverseApproval: "reverseApproval",
    paymentTravelExpenses: 'paymentTravelExpenses',
    paymentBalance: "paymentBalance",
    paymentAdvance: "paymentAdvance",
    paymentCargo: "paymentCargo",
    generateAccountingFiles: 'generateAccountingFiles',
    downloadJournalCargoPDF: 'downloadJournalCargoPDF',
    generateJournalCargo: 'generateJournalCargo',
    editSimpleRegimen: "editSimpleRegimen",
    modifyAdditionalCostBilled: "modifyAdditionalCostBilled",
    modifyAdditionalCostpayed: "modifyAdditionalCostpayed",
    addAdditionalServiceCargoPaid: "addAdditionalServiceCargoPaid",
    addAdditionalServiceCargoCashed: "addAdditionalServiceCargoCashed",
    addAdditionalServiceCargoApproved: "addAdditionalServiceCargoApproved",
    editRateCargoUnrestricted: 'editRateCargoUnrestricted',
    fastPaymentRequest: "fastPaymentRequest",
    adminReceivable: "adminReceivable",
    createReceivable: "createReceivable",
    deleteReceivable: "deleteReceivable",
    viewPaymentsReceivables: "viewPaymentsReceivables",
    billingWithFlexibilityChoice: "billingWithFlexibilityChoice",
    unrestrictedAdvancePayments: "unrestrictedAdvancePayments",
    unrestrictedAdvancePaymentsRequest: "unrestrictedAdvancePaymentsRequest",
    deleteCostCenter: "deleteCostCenter",
    financialActionsAfterApproval: "financialActionsAfterApproval",
    approvePaymentsWithTravelExpensesPending: "approvePaymentsWithTravelExpensesPending",
    paymentAdditionalCosts: "paymentAdditionalCosts",
    travelExpensesChecking: "travelExpensesChecking",
    loggiappPaymentExecute: "loggiapp.payment.execute",
    doPaymentsReceivable: "doPaymentsReceivable",
    deleteAdditionalServicesBilled: "deleteAdditionalServicesBilled",
    deleteAdditionalServicesApproved: "deleteAdditionalServicesApproved",
    rndcFulfillments: "rndcFulfillments",
    fulFillCargosRndc: "fulFillCargosRndc",
    preBill: "preBill",
  },
  guide: {
    module: "guide",
    //loadGuides: "loadGuides",
    //changeStateGuides: "changeStateGuides",
    //createGuidesFromExcel: "createGuidesFromExcel",
    guideList: "guideList",
    trackGuide: "trackGuide",
    addNoveltyToGuide: "addNoveltyToGuide",
    editGuideNovelties: "editGuideNovelties",
    editUseEvidenceToGuides: "editUseEvidenceToGuides"
  },
  point: {
    module: "point",
    createPoint: "createPoint",
    listPoints: "listPoints",
    removePoint: "removePoint",
    updatePoint: "updatePoint",
  },
  routes: {
    module: "routes",
    routePlanning: "routePlanning",
    createRoutePlanning: "createRoutePlanning",
    createRouteItinerary: "createRouteItinerary",
    editRouteItinerary: "editRouteItinerary",
    routeSites: "routeSites",
    createRouteSites: "createRouteSites",
    editRouteSites: "editRouteSites",
    deleteRouteSites: "deleteRouteSites",
    routeCriticZones: "routeCriticZones",
    createCriticZones: "createCriticZones",
    editCriticZones: "editCriticZones",
    accessCargoRoutePlanning: "accessCargoRoutePlanning",
    editCargoRoutePlanning: "editCargoRoutePlanning",
    assignRouteItineraryUnrestricted: "assignRouteItineraryUnrestricted",
  },
  setting: {
    module: "setting",
    companyDocuments: "companyDocuments",
    changePassword: "changePassword",
    termsAndConditions: "termsAndConditions",
    privacyPolicy: "privacyPolicy",
    personalDataPolicies: "personalDataPolicies",
    habeasData: "habeasData",
    termsManifest: "termsManifest",
    bascPolicies: "bascPolicies",
    quickPay: "quickPay"
  },
  helpDesk: {
    module: "help-desk",
    createTicket: "createTicket",
    listTicket: "listTicket",
    replyTechnicalTicket: "replyTechnicalTicket",
    replyWebTicket: "replyWebTicket",
    replyMobileTicket: "replyMobileTicket",
    replyOtherTicket: "replyOtherTicket",
    reopenTicket: "reopenTicket",
  },
  monitoring: {
    module: "monitoring",
    monitorlogging: "monitorlogging",
    fingerprints: "fingerprintslogging",
  },
  analytics: {
    module: "analytics",
    analyticsOperations: "analyticsOperations",
    vehicleAnalytics: "vehicleAnalytics",
    frequentRoutes: "frequentRoutes",
    dispatch: "dispatch",
    stopedCargos: "stopedCargos",
    historicalKPI: "historicalKPI",
    paymentsDashboard: "paymentsDashboard",
    analyticsBilling: "analyticsBilling",
    operationITR: "operationITR",
    operationsTurn: "operationsTurn",
    comercialTurn: "comercialTurn",
    sicetac: "sicetac",
    vehiclesOwnFleet: "vehiclesOwnFleet",
    historicalDocuments: "historicalDocuments",
    profitabilityAnalysis: "profitabilityAnalysis",
    lostSales: "lostSales",
    reportUIAF: "reportUIAF",
    fulfillments: "fulfillments",
    fulfillmentsClients: "fulfillmentsClients",
  },
  routing: {
    module: "routing",
    createRouting: "createRouting",
    routingList: "routingList",
  },
  reports: {
    module: "reports",
    cargoFinancialGeneral: "cargoFinancialGeneral"
  },
  fintech: {
    module: "fintech",
    // Autenticación
    loggicashAuthLoginFromToken: "loggicash.auth.login.fromToken",
    // Solicitudes de pago
    loggicashPaymentRequestsList: "loggicash.paymentRequests.list",
    loggicashPaymentRequestsView: "loggicash.paymentRequests.view",
    loggicashPaymentRequestsCreate: "loggicash.paymentRequests.create",
    loggicashPaymentRequestsUpdate: "loggicash.paymentRequests.update",
    loggicashPaymentRequestsDelete: "loggicash.paymentRequests.delete",
    loggicashPaymentRequestsDownloadReport: "loggicash.paymentRequests.downloadReport",
    // Payment
    loggicashPaymentCreate: "loggicash.payment.create",
    loggicashPaymentDelete: "loggicash.payment.delete",
    loggicashPaymentUpdate: "loggicash.payment.update",
    loggicashPaymentDownloadFile: "loggicash.payment.downloadFile",
    // Payment History
    loggicashPaymentHistoryList: "loggicash.paymentHistory.list",
    loggicashPaymentHistoryView: "loggicash.paymentHistory.view",
    loggicashPaymentHistoryUpdate: "loggicash.paymentHistory.update",
    loggicashPaymentHistoryDownloadReport: "loggicash.paymentHistory.downloadReport",
    loggicashPaymentHistoryUploadFile: "loggicash.paymentHistory.uploadFile",
    // Billing
    loggicashBillingList: "loggicash.billing.list",
    // Accounting
    loggicashAccountingList: "loggicash.accounting.list",
  },
  seals: {
    module: "seals",
    adminSeals: "adminSeals",
  },
  legalDocuments: {
    module: "legalDocuments",
    adminLegalDocuments: "adminLegalDocuments",
  },
  rndc: {
    module: "rndc",
    viewRndcStatus: "viewRndcStatus",
  },
  // Modulo solo-permiso: visible/usable solo para usuarios con correo @innovbo.com
  // (gating de dominio aplicado en PermissionRole.hasPermission).
  satelliteTracking: {
    module: "satelliteTracking",
    forceMonitorTracking: "forceMonitorTracking",
  }
};

export const PermissionJLRB = {
  administration: {
    module: "administration",
    adminVehicles: "adminVehicles",
    adminSatelliteLock: "adminSatelliteLock",
    adminUsers: "adminUsers",
    adminRoles: "adminRoles",
    adminCompanies: "adminCompanies",
    createCompany: "createCompany",
    updateCompany: "updateCompany",
    changeCommercial: "changeCommercial",
    createDriver: "createDriver",
    adminTrailers: "adminTrailers",
    disableEnableUsers: "disableEnableUsers",
    disableEnableDriver: "disableEnableDriver",
    createRoles: "createRoles",
    updateRoles: "updateRoles",
    changeRole: "changeRole",
    modifyBasicFieldsUser: "modifyBasicFieldsUser",
    validateDocumentsPendingDrivers: "validateDocumentsPendingDrivers",
    showSecurityAnalysis: "showSecurityAnalysis",
    activateByScore: "activateByScore",
    updateVehicle: "updateVehicle",
    createVehicle: "createVehicle",
    downloadFileRegistreBank: "downloadFileRegistreBank",
    activateVehicle: "activateVehicle",
    validateAndRemarkVehicleReferences: "validateAndRemarkVehicleReferences",
    forceVehicleActivation: "forceVehicleActivation",
    editOwnerVehicle: "editOwnerVehicle",
    editGpsVehicle: "editGpsVehicle",
    deactivateVehicle: "deactivateVehicle",
    editAdminVehicle: "editAdminVehicle",
    validateVehicleDocuments: "validateVehicleDocuments",
    editReferencesVehicle: "editReferencesVehicle",
    changeRolNotifications: "changeRolNotifications",
    editCompliments: "editCompliments",
    createEmailCompany: "createEmailCompany",
    editTags: "editTags",
    vehicleDocumentsConfiguration: "vehicleDocumentsConfiguration",
    changeValidationRules: "changeValidationRules",
    truoraConfiguration: "truoraConfiguration",
    reactivateVehicleByInactivity: "reactivateVehicleByInactivity",
    editFieldsRUNT: "editFieldsRUNT",
    showDocumentsPendingDrivers: "showDocumentsPendingDrivers",
    editThirdPartyAddress: "editThirdPartyAddress",
    activateOrDeactivateCompany: "activateOrDeactivateCompany",
    deleteEmailCompany: "deleteEmailCompany",
    createSatelliteLock: "createSatelliteLock",
    updateSatelliteLock: "updateSatelliteLock",
    deleteSatelliteLock: "deleteSatelliteLock",
  },
  cargo: {
    module: "cargo",
    readDriverDetails: "readDriverDetails",
    addDocumentsSupport: "addDocumentsSupport",
    saveDriverDocuments: "saveDriverDocuments",
    updateBankAdvance: "updateBankAdvance",
    updateBankBalance: "updateBankBalance"
  },
  payments: {
    module: "payments",
    editSimpleRegimen: "editSimpleRegimen",
    approveBankAdvance: "approveBankAdvance",
    approveBankBalance: "approveBankBalance"
  }
};
